import stableStringify from 'fast-json-stable-stringify';
import { recordSortDuration } from './sortPerfBuffer';
function normalizeFilter(filter) {
  return filter.values != null ? Object.assign({}, filter, {
    values: [...filter.values].sort()
  }) : filter;
}
function normalizeCrossObjectFilters(crossObjectFilters) {
  const normalized = crossObjectFilters.map(cof => cof.filterGroups != null ? Object.assign({}, cof, {
    filterGroups: _sortFilterGroupsImpl(cof.filterGroups)
  }) : cof);
  return normalized.sort((a, b) => {
    const keyA = stableStringify(a);
    const keyB = stableStringify(b);
    return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
  });
}
function _sortFilterGroupsImpl(filterGroups) {
  const withKeys = filterGroups.map(group => {
    const filtersWithKeys = group.filters.map(filter => {
      const normalized = normalizeFilter(filter);
      return {
        filter: normalized,
        key: stableStringify(normalized)
      };
    });
    filtersWithKeys.sort((a, b) => a.key < b.key ? -1 : a.key > b.key ? 1 : 0);
    const normalizedGroup = group.crossObjectFilters != null ? Object.assign({}, group, {
      filters: filtersWithKeys.map(({
        filter
      }) => filter),
      crossObjectFilters: normalizeCrossObjectFilters(group.crossObjectFilters)
    }) : Object.assign({}, group, {
      filters: filtersWithKeys.map(({
        filter
      }) => filter)
    });
    return {
      group: normalizedGroup,
      groupKey: filtersWithKeys.map(({
        key
      }) => key).join('\x02')
    };
  });
  withKeys.sort((a, b) => a.groupKey < b.groupKey ? -1 : a.groupKey > b.groupKey ? 1 : 0);
  return withKeys.map(({
    group
  }) => group);
}
export function sortFilterGroups(filterGroups, {
  context
} = {
  context: 'standard'
}) {
  const start = performance.now();
  const result = _sortFilterGroupsImpl(filterGroups);
  recordSortDuration({
    durationMs: performance.now() - start,
    context
  });
  return result;
}
export const normalizeVariables = (variables, context) => Object.assign({}, variables, {
  filterGroups: sortFilterGroups(variables.filterGroups, {
    context
  })
});